import { useEffect, useState } from 'react';

export const useShowEntityBottomBar = (contentRef, extraCondition = true) => {
	const [showEntityBottomBar, setShowEntityBottomBar] = useState(
		extraCondition
	);

	useEffect(() => {
		const viewportHeight = document.documentElement.clientHeight;
		const mainContentHeight = contentRef?.current?.clientHeight;

		if (mainContentHeight < viewportHeight && extraCondition) {
			setShowEntityBottomBar(false);
		}
	}, [contentRef]);

	return showEntityBottomBar;
};
